import React, { useEffect, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";
import DemoPopup from "../demopopup"; // 👈 import popup

const SectionSeven = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const [showPopup, setShowPopup] = useState(false);
  return (
    <div className="section-seven-checkout">
      <div className="container-fluid">
        <div
          className="flex align-items-center sect-5"
          style={{
            justifyContent: isMobile ? "center" : "space-between",
            gap:  isMobile ? "8px" :"30px",
            margin: isMobile ? "0 0.2rem" : "0 5rem",
          }}
        >
          <div
            className="mid-text1-checkout-seven"
            style={{ justifyContent: "left" }}
          >
            <h1 style={{ justifyContent: "left", display: "flex" }}>
              Launch Fast,
            </h1>
            <h1 style={{ justifyContent: "left", display: "flex" }}>
              Scale Faster
            </h1>
          </div>

          <div className="mid-text1-checkout-seven-right">
            <p style={{ justifyContent: "left", display: "flex" }}>
              100% conversion-ready
            </p>

            <div>
              <button
                className="cta3-checkout-seven "
                onClick={() => setShowPopup(true)}
              >
                Book a Demo
              </button>
            </div>
          </div>
        </div>
      </div>
      <DemoPopup show={showPopup} onClose={() => setShowPopup(false)} />
    </div>
  );
};

export default SectionSeven;
